import { Key } from "react";
export class DelayColorIndicator{
    delay : number;
    color : string;
    constructor(delay: number, color: string) {
      this.delay = delay;
      this.color = color;
    }
}
interface LayoutDefinition {
    key:Key;
    columnname: string;
    width: number;
    textAlignment: any;
    headerTextGerman: string;
    headerTextEnglish: string;
}
class GlobalConfiguration{

// export default LayoutDefinition
public static Config: LayoutDefinition[] = [
    
];


/**
 * ---------- Departure
 */

public static ConfigWithPlatform:LayoutDefinition[] = [
    {
        key:0,
        columnname: "Time",
        headerTextEnglish: "departure",
        headerTextGerman: "Abfahrt",
        textAlignment: "center",
        width: 150
    },
    {
        key:1,
        columnname: "Estimated",
        headerTextEnglish: "estimated",
        headerTextGerman: "Erwartet",
        textAlignment: "center",
        width: 150
    },
    {
        key:2,
        columnname: "Platform",
        headerTextEnglish: "platform",
        headerTextGerman: "Steig",
        textAlignment: "center",
        width: 150
    },
    {
        key:3,
        columnname: "Line",
        headerTextEnglish: "line",
        headerTextGerman: "Linie",
        textAlignment: "center",
        width: 150
    },
    {
        key:4,
        columnname: "Direction",
        headerTextEnglish: "direction",
        headerTextGerman: "Richtung",
        textAlignment: "left",
        width: 700
    },
    {
        key:5,
        columnname: "VIAText",
        headerTextEnglish: "annotation",
        headerTextGerman: "Anmerkung",
        textAlignment: "left",
        width: 620
    },
];


public static ConfigWithoutPlatform:LayoutDefinition[]=[{
    key:0,
    columnname: "Time",
    headerTextEnglish: "departure",
    headerTextGerman: "Abfahrt",
    textAlignment: "center",
    width: 150
},
{
    key:1,
    columnname: "Estimated",
    headerTextEnglish: "estimated",
    headerTextGerman: "Erwartet",
    textAlignment: "center",
    width: 150
},
{
    key:2,
    columnname: "Line",
    headerTextEnglish: "line",
    headerTextGerman: "Linie",
    textAlignment: "center",
    width: 150
},
{
    key:3,
    columnname: "Direction",
    headerTextEnglish: "direction",
    headerTextGerman: "Richtung",
    textAlignment: "left",
    width: 770
},
{
    key:4,
    columnname: "VIAText",
    headerTextEnglish: "annotation",
    headerTextGerman: "Anmerkung",
    textAlignment: "left",
    width: 700
},
];

/**
 * ---------- Arrival
 */


public static ConfigWithPlatformArrival:LayoutDefinition[] = [
    {
        key:0,
        columnname: "Time",
        headerTextEnglish: "arrival",
        headerTextGerman: "Ankunft",
        textAlignment: "center",
        width: 150
    },
    {
        key:1,
        columnname: "Estimated",
        headerTextEnglish: "estimated",
        headerTextGerman: "Erwartet",
        textAlignment: "center",
        width: 150
    },
    {
        key:2,
        columnname: "Platform",
        headerTextEnglish: "platform",
        headerTextGerman: "Steig",
        textAlignment: "center",
        width: 150
    },
    {
        key:3,
        columnname: "Line",
        headerTextEnglish: "line",
        headerTextGerman: "Linie",
        textAlignment: "center",
        width: 150
    },
    {
        key:4,
        columnname: "Direction",
        headerTextEnglish: "direction",
        headerTextGerman: "Richtung",
        textAlignment: "left",
        width: 700
    },
    {
        key:5,
        columnname: "VIAText",
        headerTextEnglish: "annotation",
        headerTextGerman: "Anmerkung",
        textAlignment: "left",
        width: 620
    },
];


public static ConfigWithoutPlatformArrival:LayoutDefinition[]=[{
    key:0,
    columnname: "Time",
    headerTextEnglish: "arrival",
    headerTextGerman: "Ankunft",
    textAlignment: "center",
    width: 150
},
{
    key:1,
    columnname: "Estimated",
    headerTextEnglish: "estimated",
    headerTextGerman: "Erwartet",
    textAlignment: "center",
    width: 150
},
{
    key:2,
    columnname: "Line",
    headerTextEnglish: "line",
    headerTextGerman: "Linie",
    textAlignment: "center",
    width: 150
},
{
    key:3,
    columnname: "Direction",
    headerTextEnglish: "direction",
    headerTextGerman: "Richtung",
    textAlignment: "left",
    width: 770
},
{
    key:4,
    columnname: "VIAText",
    headerTextEnglish: "annotation",
    headerTextGerman: "Anmerkung",
    textAlignment: "left",
    width: 700
},
];


public static RefreshIntervallMilliseconds:number= 30000 //30 seconds
public static NoMoreDepartures:string="Keine weiteren Abfahrten"
public static NextDepartureOn:string="Nächste Abfahrten am "
public static showRealtime = false;
public static delayColorIndicator1 = new DelayColorIndicator(0, "#000000");
public static delayColorIndicator2: DelayColorIndicator = new DelayColorIndicator(60 * 1000, "#000000");
public static delayColorIndicator3: DelayColorIndicator = new DelayColorIndicator(5 * 60 * 1000, "#ba4040");
}
export default GlobalConfiguration;